// extracted by mini-css-extract-plugin
module.exports = {"eventSession":"EventSession_eventSession_2fktp","isStyleApply":"EventSession_isStyleApply_3P4RY","courseSession":"EventSession_courseSession_3r9qH"};